export default __webpack_public_path__ + "static/new-liquid-pool-cedd3085966efb3c999979e25e39be01.svg";